import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import CallAction from "../Components/CallAction";

const Facilities = () => {
  const [facilitieDetails, setFacilitieDetails] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get("JSON/facilities.json").then((response) => {
      setFacilitieDetails(response.data);
    });
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Facilities</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/facilities">Facilities</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {facilitieDetails.map((facilitieDetail, index) =>
        index % 2 === 0 ? (
          <section
            className="eschool-facilities-section section-1"
            key={facilitieDetail?.id}
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-12">
                  <div className="eschool-facilities-img-slider">
                    <Swiper
                      modules={[Navigation, Autoplay]}
                      spaceBetween={0}
                      slidesPerView={1}
                      navigation
                      loop={true}
                      autoplay={{
                        delay: 5000,
                      }}
                    >
                      {facilitieDetail?.images.map((SingleImgSlider, index) => (
                        <SwiperSlide key={index}>
                          <div className="facilities-img-single">
                            {" "}
                            <img src={SingleImgSlider} alt="#" />
                            <span className="img-slider-number">
                              {index + 1}/{facilitieDetail?.images?.length}
                            </span>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="eschool-facilities-content">
                    <span className="facilities-cont-sm-title">Facilities</span>
                    <h3 className="facilities-cont-big-title">
                      {facilitieDetail?.title}
                    </h3>
                    <p className="facilities-cont-text">
                      {facilitieDetail?.detail}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section
            className="eschool-facilities-section section-2"
            key={facilitieDetail?.id}
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-12">
                  <div className="eschool-facilities-content">
                    <span className="facilities-cont-sm-title">Facilities</span>
                    <h3 className="facilities-cont-big-title">
                      {facilitieDetail?.title}
                    </h3>
                    <p className="facilities-cont-text">
                      {facilitieDetail?.detail}
                    </p>
                  </div>
                </div>
                <div className="col-lg-6  col-12">
                  <div className="eschool-facilities-img-slider">
                    <Swiper
                      modules={[Navigation, Autoplay]}
                      spaceBetween={24}
                      slidesPerView={1}
                      navigation
                      loop={true}
                      autoplay={{
                        delay: 6000,
                      }}
                    >
                      {facilitieDetail?.images.map((SingleImgSlider, index) => (
                        <SwiperSlide key={index}>
                          <div className="facilities-img-single">
                            {" "}
                            <img src={SingleImgSlider} alt="#" />
                            <span className="img-slider-number">
                              {index + 1}/{facilitieDetail?.images?.length}
                            </span>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )
      )}

      <CallAction />
    </>
  );
};

export default Facilities;
